import React, { useContext } from "react";
import { Button, Box } from "@chakra-ui/react";
import { LanguageContext } from "../components/LanguageProvider"; // Importujemy kontekst językowy
import { messages } from "../intl/config"; // Import dostępnych tłumaczeń

type Props = {
  text: string;
};

export default function CtaButtonEmail(props: Props): JSX.Element {
  const { locale = "en" } = useContext(LanguageContext); // Pobranie aktualnego języka z kontekstu
  const translations = messages[locale] || {}; // Tłumaczenia na podstawie języka

  // Funkcja kopiująca tekst do schowka
  const copyToClipboard = () => {
    navigator.clipboard.writeText(props.text).then(
      () => {
        alert(
          translations["ctaButtonEmail.copySuccess"].replace(
            "{{email}}",
            props.text
          )
        ); // Powiadomienie o sukcesie z dynamicznym emailem
      },
      (err) => {
        console.error(translations["ctaButtonEmail.copyError"], err); // Powiadomienie o błędzie
      }
    );
  };

  return (
    <Box>
      <Button
        onClick={copyToClipboard}
        size="md"
        fontWeight={500}
        variant="ctaSolidLight"
      >
        {props.text}
      </Button>
    </Box>
  );
}
